import React from "react";
import BaseModal from "../BaseModal/index.tsx";
import CadastroPaciente from "../../CadastroPaciente/index.tsx";

const CadastroPacienteModal = ({ isOpen, onClose, onAdd }) => {
  return (
    <BaseModal isOpen={isOpen} title="Cadastro de Paciente" onClose={onClose}>
      <CadastroPaciente onAdd={onAdd} />
    </BaseModal>
  );
};

export default CadastroPacienteModal;
